import { ShieldCheck, Lock, Globe2, FileCheck2, EyeOff, BadgeCheck, KeyRound } from "lucide-react";

const items = [
  { Icon: ShieldCheck, label: "GDPR compliant", tone: "mkt-gradient-hero" },
  { Icon: BadgeCheck, label: "SOC 2 (in progress)", tone: "mkt-gradient-purple" },
  { Icon: EyeOff, label: "100% anonymous by design", tone: "mkt-gradient-teal" },
  { Icon: Globe2, label: "EU data residency", tone: "mkt-gradient-sunset" },
  { Icon: FileCheck2, label: "PII auto-strip pre-database", tone: "mkt-gradient-hero" },
  { Icon: KeyRound, label: "ISO 27001 aligned", tone: "mkt-gradient-purple" },
  { Icon: Lock, label: "End-to-end encrypted", tone: "mkt-gradient-teal" },
];

export const SecurityBand = () => {
  return (
    <section className="container mx-auto px-3 lg:px-8 py-12 sm:py-16 lg:py-24">
      <div className="text-center max-w-2xl mx-auto mb-8 sm:mb-12">
        <div className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.18em] text-[hsl(var(--mkt-primary))] mb-3">
          Security & compliance
        </div>
        <h2 className="text-3xl sm:text-5xl lg:text-6xl tracking-tight leading-tight">
          <span className="block">Built For HR.</span>
          <span className="block">Trusted By Legal.</span>
        </h2>
        <p className="mt-3 sm:mt-4 text-sm sm:text-base text-muted-foreground">
          Anonymity isn't a feature here — it's the architecture.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
        {items.map(({ Icon, label, tone }, i) => {
          const isLast = i === items.length - 1;
          return (
            <div
              key={label}
              className={`group relative rounded-2xl sm:rounded-3xl bg-card border border-border mkt-shadow-card p-3.5 sm:p-5 lg:p-6 flex items-center gap-3 sm:gap-4 transition hover:-translate-y-0.5 justify-center sm:justify-start text-center sm:text-left ${isLast ? "col-span-2 md:col-span-1" : ""}`}
            >
              <div className={`relative h-10 w-10 sm:h-11 sm:w-11 shrink-0 rounded-2xl ${tone} mkt-grain overflow-hidden inline-flex items-center justify-center text-white`}>
                <Icon className="h-4.5 w-4.5 sm:h-5 sm:w-5 relative" />
              </div>
              <div className="text-[13px] sm:text-sm font-semibold text-foreground leading-snug">
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
